module.exports = __webpack_public_path__ + "static/media/400066_02.13eb7a8b.png";